import { TRootState } from 'Redux/Reducers';

export const getAppUserOrganisations = (state: TRootState) => state.appUser.organisations;
